module.exports = __webpack_public_path__ + "img/59.5cc88da9.jpg";